import React from 'react';
import {QueryClientProvider} from '@tanstack/react-query';

import {CustomEventsProvider} from 'common/contexts/react/custom-events-context';
import {DataGroupProvider} from 'common/contexts/react/data-group-context';
import {dataGroupStore} from 'common/report/stores/data-groups';
import {EventPropertyDefinitionsProvider} from 'common/contexts/react/event-property-definition-context';
import {EventDefinitionsProvider as LegacyEventDefinitionsProvider} from 'common/contexts/react/legacy-event-definition-context';
import {LookupTablesProvider} from 'common/contexts/react/lookup-tables-context';
import {OpenInNewTabProvider} from 'common/contexts/react/open-in-new-tab-context';
import {PeoplePropertyDefinitionsProvider} from 'common/contexts/react/people-property-definition-context';
import {Providers} from 'common/util/react';
import {lookupTablesStore} from 'common/report/stores/lookup-tables';
import {eventPropertyDefinitionsStore, peoplePropertyDefinitionsStore} from 'common/report/stores/property-definitions';
import {customEventsStore} from 'common/report/stores/custom-events';
import {eventDefinitionsStore} from 'common/report/stores/event-definitions';
import {queryClient} from 'common/react-query/query-client';

import {Routes} from './routes';

export const App = () => {
  const providers = [
    // window.open has to have `window` as context, force binding it here
    <OpenInNewTabProvider value={window.open.bind(window)} />,

    // legacy stores we use
    <CustomEventsProvider value={customEventsStore} />,
    <DataGroupProvider value={dataGroupStore} />,
    <LegacyEventDefinitionsProvider value={eventDefinitionsStore} />,
    <EventPropertyDefinitionsProvider value={eventPropertyDefinitionsStore} />,
    <LookupTablesProvider value={lookupTablesStore} />,
    <PeoplePropertyDefinitionsProvider value={peoplePropertyDefinitionsStore} />,
    <QueryClientProvider client={queryClient} />,
  ];

  return (
    <Providers providers={providers}>
      <Routes />
    </Providers>
  );
};

// eslint-disable-next-line import/no-default-export
export default App;
